export const REPORT_TYPE = {
  VIDEOS: 'videos',
  IMAGE: 'images',
};

export const UploadType = {
  local: 'local',
  bim: 'bim',
};

export const ROLE_TYPE = {
  '3D': 'PROJECT_EDITOR', // Mapped from 360_DOCUMENTER to PROJECT_EDITOR
  SA: 'ORG_SUPER_ADMIN', // Mapped from SUPER_ADMIN to ORG_SUPER_ADMIN
  OSA: 'ORG_SUPER_ADMIN',
  ADMIN: 'ORG_ADMIN', // Mapped from ADMIN to ORG_ADMIN
  OA: 'ORG_ADMIN',
  OM: 'ORG_MEMBER',
  PA: 'PROJECT_ADMIN',
  PE: 'PROJECT_EDITOR',
  PM: 'PROJECT_MEMBER',
  PV: 'PROJECT_VIEWER',
  OE: 'ORG_OPERATION_ENGINEER', // Keep as-is
};
export const FLOOR_STATUS = {
  FAILED: 'FAILED',
  UNDER_PROCESS_BY_AI: 'UNDER_PROCESS_BY_AI',
  PUBLISHED_BY_OPERATION_ENG: 'PUBLISHED_BY_OPERATION_ENG',
  READY_FOR_OPERATION_ENG: 'READY_FOR_OPERATION_ENG',
  BLURRING_IN_PROGRESS: 'BLURRING_IN_PROGRESS',
};
export const REPORT_STATUS = {
  PUBLISHED: 'PUBLISHED',
  PARTIALLY_PUBLISHED: 'PARTIALLY_PUBLISHED',
  FAILED: 'FAILED',
};
export const OTP_METHOD = {
  DISABLED: 'DISABLED',
  SMS: 'SMS',
  EMAIL: 'EMAIL',
  BOTH: 'BOTH',
};
